import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button,Container} from 'react-bootstrap';
import './Home.css';
import titleImage from './assets/title.png';
import lionsImage from './assets/Logo-myn.png';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">


  <div className="text-container">
    <p className="title1st-text">Mynämäen joulukonsertti</p>
    <p className="artist">Anne Mattilan joulu</p>
  </div>

  <div className="main-container">
  <h2 className="text1st">Mynämäen Pyhän Laurin kirkko</h2>
  <h2 className="text1st">Kirkkokatu 3</h2>
  <h2 className="text1st">Tiistaina 1.12.2026</h2>
  <h2 className="text1st">Klo 18.00 - 19.00</h2>
  <h2 className="text1st">Liput 25 € / kpl</h2>

  <Container className="d-flex justify-content-center gap-3 mt-5" style={{ maxWidth: '300px' }}>
    <Button
      variant="outline-dark"
      className="reservation-button flex-fill w-50 text-white"
      onClick={() => navigate('/varaa')}
    >
      Varaa
    </Button>
    <Button
      variant="outline-dark"
      className="cancellation-button w-50 flex-fill text-white"
      onClick={() => navigate('/peruutavaraus')}
    >
      Peruuta varaus
    </Button>
  </Container>
        <div className="logot-bck">
        
      </div>
      <img className="logot" src={lionsImage} alt="A picture of a lion"></img>
    </div>
</div>
  );
}

export default Home;